export default __webpack_public_path__ + "static/media/KI.663aec5c.svg";